export default "__VITE_ASSET__DLGHLUo9__"